import { useMutation, useQuery } from "@apollo/client";
import {
  Box,
  Divider,
  Drawer,
  FormControl,
  FormControlLabel,
  FormHelperText,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  RadioGroup,
  Radio,
  useTheme,
} from "@mui/material";
import * as Yup from "yup";
import { useMemo, useState } from "react";

import { useParams } from "react-router-dom";
import { SimpleLoader } from "../../Loader/Loader";
import { Specification } from "../../../Sources/All/AddSource/Internal/Specification";
import {
  CreateTransformationServiceDocument,
  CreateWarehouseServiceDocument,
  GetCurrentUserInfoDocument,
  GetTransformationServicesDocument,
  GetWarehouseServicesDocument,
  GetWorkspaceInfoDocument,
  TransformationServiceProvider,
  UpsertWarehouseConfigDocument,
  WarehouseServiceProvider,
} from "../../../generated";
import { Button } from "../../Button/Button";
import { Formik } from "formik";
import { CustomTextField } from "../../CustomTextField/CustomTextField";
import { toast } from "react-toastify";
import { Fields } from "./Fields";
import RightSidePanel from "../../RightSidePanel";
import {
  ButtonPrimary,
  PanelHolder,
  PanelContent,
  PanelTopContent,
  PanelContentHead,
  HeadSmallTitle,
  HeadTitle,
  SubHeading,
  RadioHolder,
  LabelTitle,
  LableDes,
  FormCenter,
  FooterBtnHolder,
} from "../style";
import { FieldsHolder, FieldsSet, Label } from "../style";

export const AddWarehouseConfig = ({ open, setOpen, warehouseData }: any) => {
  const close = () => {
    setOpen(false);
  };
  const { workspaceId } = useParams();
  const { palette } = useTheme();

  const [create, { loading }] = useMutation(UpsertWarehouseConfigDocument, {
    refetchQueries: [GetWarehouseServicesDocument],
  });

  const { data } = useQuery(GetCurrentUserInfoDocument);

  const { data: workspaceInfo, loading: workspaceInfoLoading } = useQuery(
    GetWorkspaceInfoDocument,
    {
      variables: {
        input: {
          workspaceId: workspaceId || "",
        },
      },
    }
  );

  const inputs = useMemo(
    () =>
      warehouseData.provider === WarehouseServiceProvider.Snowflake
        ? ["apiKey", "apiEndpoint", "accountId"]
        : ["username", "password", "host", "port"],
    [warehouseData]
  );

  return (
    <>
      <Formik
        validationSchema={Yup.object().shape({
          type: Yup.string(),
          username: Yup.string(),
          password: Yup.string(),
          apiKey: Yup.string(),
          apiEndpoint: Yup.string(),
          accountId: Yup.string(),
          host: Yup.string(),
          port: Yup.number(),
        })}
        validateOnBlur={true}
        validateOnChange={true}
        initialValues={{
          type: warehouseData?.provider,
          username: "",
          password: "",
          apiKey: "",
          apiEndpoint: "",
          accountId: "",
          port: "",
          host: "",
        }}
        onSubmit={(values) => {
          create({
            variables: {
              workspaceId: workspaceId || "",
              warehouseId: warehouseData?.id || "",
              config: values,
            },
          }).then((res) => {
            if (res.data?.upsertWarehouseConfig.success) {
              toast.success("Warehouse Configurations created successfully");
              setOpen(false);
            } else {
              toast.error("Something went wrong");
            }
          });
        }}
      >
        {({
          handleChange,
          errors,
          touched,
          handleSubmit,
          values,
          handleBlur,
          setFieldValue,
          isValid,
          resetForm,
        }) => (
          <form onSubmit={handleSubmit}>
            <PanelContent>
              <PanelTopContent>
                <PanelContentHead>
                  <HeadSmallTitle>Warehouse</HeadSmallTitle>
                  <HeadTitle>New Warehouse</HeadTitle>
                </PanelContentHead>

                <FormCenter>
                  <HeadTitle>About</HeadTitle>
                  <FieldsSet>
                    <SubHeading className="add">
                      Warehouse Service name
                    </SubHeading>
                    <Typography variant="body2" color="gray.darkest">
                      {warehouseData?.name}
                    </Typography>
                  </FieldsSet>

                  <HeadTitle className="mt">Configurations</HeadTitle>
                  {inputs.map((field) => (
                    <FieldsHolder key={field}>
                      <LabelTitle>{field}</LabelTitle>
                      <CustomTextField
                        name={field}
                        onBlur={handleBlur}
                        value={(values as any)?.[field]}
                        onChange={handleChange}
                        error={(errors as any)?.[field]}
                        touched={(touched as any)?.[field]}
                        type={field === "password" ? "password" : "text"}
                      />
                    </FieldsHolder>
                  ))}
                </FormCenter>
              </PanelTopContent>
              <FooterBtnHolder>
                <Button onClick={() => setOpen(false)} variant="outlined">
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!isValid || loading}
                  type="submit"
                >
                  Add Service
                </Button>
              </FooterBtnHolder>
            </PanelContent>
          </form>
        )}
      </Formik>
    </>
  );
};
